export const breakPoints = {
  xlDesktop: `@media (min-width: 1919px)`,
  desktop: `@media (min-width: 1039px)`,
  tablet: `@media (min-width: 767px)`,
  smallScreen: `@media (min-width: 374px)`,
};
